module.exports = __webpack_public_path__ + "img/detailedDesign.b281807c.svg";